import axios from 'axios';
import Vue from 'vue';
import router from '../src/router/index'

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    /* baseURL: 'http://localhost:3000/admin' */

})

//请求拦截器
http.interceptors.request.use((config) => {
    // Do something before request is sent
    if (localStorage.token) {
        config.headers.Authorization = 'Bearer ' + localStorage.token || '';
    }
    return config;
}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});

//响应拦截器

http.interceptors.response.use(res => {
    return res
}, error => {
    //console.log(error.response.data)
    if (error.response.data) {

        Vue.prototype.$message({
            type: 'error',
            message: error.response.data.msg || error.response.data.error[0].msg
        });
        if (error.response.status == 402) {
            router.push('/login')
        }

    }
    //console.log(error.response.data.msg)
    return Promise.reject(error)
})

export default http